import axios from "axios";

// Use environment variable for backend URL, default to localhost for local development
const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
